import { memo, useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from '@tabeeb/store'
import {
  resetUsersSearchState,
  searchUserForSharing,
  setUserForSharing,
  updateSearchUserText,
} from '@tabeeb/modules/contentSharings/actions'
import { getContentSharingDialogState, getUserSearchState } from '@tabeeb/modules/contentSharings/selectors'
import { useDebouncedValue } from '@tabeeb/modules/shared/utils/hooks'
import { SearchResultRowBtn } from '@tabeeb/modules/contentSharings/constants/enums'
import { Stack, TextField } from '@collaborate-health/uikit'
import SearchUsersResult from '../SearchUsersResult'
import UserSearchResultItem from '../UserSearchResultItem'

interface UserSelectProps {
  isDisabled: boolean
}

const UserSelect: React.FC<UserSelectProps> = ({ isDisabled }) => {
  const dispatch = useDispatch()
  const { tenant, user } = useSelector(getContentSharingDialogState)
  const { searchText } = useSelector(getUserSearchState)
  const debouncedSearchQuery = useDebouncedValue(searchText, 500)

  useEffect(() => {
    if (searchText && debouncedSearchQuery && tenant) {
      dispatch(searchUserForSharing.request({ search: debouncedSearchQuery, tenantId: tenant.Id }))
    }

    if (!searchText) {
      dispatch(resetUsersSearchState())
    }
  }, [debouncedSearchQuery, dispatch, tenant, searchText])

  const _handleRemoveButtonClick = useCallback(() => {
    dispatch(setUserForSharing(null))
  }, [dispatch])

  return (
    <Stack>
      {!user && (
        <TextField
          value={searchText}
          onChange={(e) => dispatch(updateSearchUserText(e.target.value))}
          disabled={isDisabled}
        />
      )}
      <Stack>
        {!user && <SearchUsersResult />}
        {user && (
          <UserSearchResultItem
            user={user}
            button={SearchResultRowBtn.Remove}
            handleButtonClick={_handleRemoveButtonClick}
          />
        )}
      </Stack>
    </Stack>
  )
}

export default memo(UserSelect)

